import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        neutral: "px-4 py-1 bg-(--color-surface-muted) border-none rounded-full text-sm h-fit text-(--color-text-secondary)",
        soft: "border-transparent bg-(--color-surface-accent) text-(--color-text-primary) rounded-full px-2.5 py-0.5",
        success: "border-transparent bg-(--color-success-bg) text-(--color-success-text) hover:bg-(--color-success-bg)",
        warning: "border-transparent bg-(--color-warning-bg) text-(--color-warning-text) hover:bg-(--color-warning-bg)",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
